module.exports = __webpack_public_path__ + "static/ULC Stellenstamm-3ccd82a1fd6e2bbe615babfc0e862b68.jpg";